import React from 'react'
import { FaRegCircle, FaRegDotCircle } from 'react-icons/fa'

import './stylesSR.css'

export default function SelectRadio({ textA, textB, select, onClick }) {
  return (
    <button className='btt-seletor-div-radio' onClick={onClick}>
      {!select ? <FaRegCircle size={20} color={'gray'} /> : <FaRegDotCircle size={20} color={'#ff7043'} />}
      <div className='contain-infos-select-radio'>
        <label className='select-text-radio-label'>{textA}</label>
        <h3 className='select-text-radio-h3'>{textB}</h3>
      </div>
    </button>
  )
}
